"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Slider = exports.SLIDER_STYLE_TYPE = exports.SLIDER_CONTAINER_CLASS_NAME = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _ReactIdSwiper = _interopRequireDefault(require("react-id-swiper/lib/ReactIdSwiper.custom"));
var _getComponentDataAttributes = require("b2b-components/utils/getComponentDataAttributes");
var _server = require("b2b-components/utils/server");
var _classnames = _interopRequireDefault(require("classnames"));
var _swiper = _interopRequireWildcard(require("swiper"));
var _upperCaseFirst = require("upper-case-first");
var _Arrow = require("./Arrow");
require("./Slider.scss");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      (0, _defineProperty2["default"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
if (!_server.isServer) {
  require('swiper/swiper-bundle.min.css');
}
var SLIDER_CONTAINER_CLASS_NAME = 'cds-Slider-Container';
exports.SLIDER_CONTAINER_CLASS_NAME = SLIDER_CONTAINER_CLASS_NAME;
var SLIDER_NUMBER_PRODUCTS_BOX_NO_NAVIGATION = 4;
var SLIDER_STYLE_TYPE = /*#__PURE__*/function (SLIDER_STYLE_TYPE) {
  SLIDER_STYLE_TYPE["default"] = "default";
  SLIDER_STYLE_TYPE["withMargin"] = "withMargin";
  return SLIDER_STYLE_TYPE;
}({});
exports.SLIDER_STYLE_TYPE = SLIDER_STYLE_TYPE;
var Slider = function Slider(_ref) {
  var _classNames;
  var breakpoints = _ref.breakpoints,
    children = _ref.children,
    className = _ref.className,
    dataAttributes = _ref.dataAttributes,
    productBoxCount = _ref.productBoxCount,
    slidesPerGroup = _ref.slidesPerGroup,
    spaceBetween = _ref.spaceBetween,
    _ref$autoplayDelay = _ref.autoplayDelay,
    autoplayDelay = _ref$autoplayDelay === void 0 ? 4000 : _ref$autoplayDelay,
    _ref$isAutoplay = _ref.isAutoplay,
    isAutoplay = _ref$isAutoplay === void 0 ? true : _ref$isAutoplay,
    _ref$isAutoplayDisabl = _ref.isAutoplayDisableOnInteraction,
    isAutoplayDisableOnInteraction = _ref$isAutoplayDisabl === void 0 ? true : _ref$isAutoplayDisabl,
    _ref$isLoop = _ref.isLoop,
    isLoop = _ref$isLoop === void 0 ? true : _ref$isLoop,
    _ref$isPagination = _ref.isPagination,
    isPagination = _ref$isPagination === void 0 ? false : _ref$isPagination,
    _ref$slidesPerView = _ref.slidesPerView,
    slidesPerView = _ref$slidesPerView === void 0 ? 1 : _ref$slidesPerView,
    _ref$styleType = _ref.styleType,
    styleType = _ref$styleType === void 0 ? SLIDER_STYLE_TYPE["default"] : _ref$styleType;
  var rootClassName = (0, _classnames["default"])('cds-Slider', className, (_classNames = {}, (0, _defineProperty2["default"])(_classNames, "cds-Slider--".concat((0, _upperCaseFirst.upperCaseFirst)(styleType || '')), styleType !== SLIDER_STYLE_TYPE["default"]), (0, _defineProperty2["default"])(_classNames, 'cds-Slider--WithMarginNoNavigationDesktop', styleType === SLIDER_STYLE_TYPE.withMargin && (productBoxCount || 0) <= SLIDER_NUMBER_PRODUCTS_BOX_NO_NAVIGATION), _classNames));
  var swiperElement = (0, _react.useRef)(null);
  var swiper = (0, _react.useRef)(null);
  var isAutoplayRunning = (0, _react.useRef)(null);
  var setAutoplayStop = (0, _react.useCallback)(function () {
    if (swiper.current && (isAutoplayRunning.current || isAutoplayRunning.current === null)) {
      swiper.current.autoplay.stop();
    }
  }, []);
  var setAutoplayStart = (0, _react.useCallback)(function () {
    if (swiper.current && (isAutoplayRunning.current || isAutoplayRunning.current === null)) {
      swiper.current.autoplay.start();
    }
  }, []);

  // the method is necessary to avoid appearing duplicate slides which are created
  // by Swiper component (they don't have events handler) and protects from clicking duplicate slides
  var setSlidesCorrectly = (0, _react.useCallback)(function (isTransitionEnd) {
    var swiperInstance = swiper.current;
    if (!swiperInstance) {
      return null;
    }
    var setPointerEventsForActiveSlide = function setPointerEventsForActiveSlide() {
      if (isTransitionEnd) {
        swiperInstance.slides[swiperInstance.activeIndex].style.pointerEvents = 'auto';
      } else {
        swiperInstance.slides[swiperInstance.activeIndex].style.pointerEvents = 'none';
      }
    };

    /*
          if user interacted with slider, autoplay is not start
        */
    var isDisableOnInteraction = isAutoplayDisableOnInteraction && swiperInstance.autoplay && swiperInstance.autoplay.running;
    if (swiperInstance && swiperInstance.isBeginning && swiperInstance.params.loop) {
      isTransitionEnd && swiperInstance.slideToLoop(_react["default"].Children.toArray(children).length - 1, 0);
      isAutoplay && isDisableOnInteraction && swiperInstance.autoplay.start();
      setPointerEventsForActiveSlide();
    }
    if (swiperInstance && swiperInstance.isEnd && swiperInstance.params.loop) {
      isTransitionEnd && swiperInstance.slideToLoop(0, 0);
      isAutoplay && isDisableOnInteraction && swiperInstance.autoplay.start();
      setPointerEventsForActiveSlide();
    }
  }, [isAutoplay, isAutoplayDisableOnInteraction, children]);
  var setAutoplayRunning = (0, _react.useCallback)(function (isRunning) {
    isAutoplayRunning.current = isRunning;
  }, []);
  var handleSwiperAutoplay = (0, _react.useCallback)(function () {
    setAutoplayRunning(true);
  }, [setAutoplayRunning]);
  var handleSwiperObserverUpdate = (0, _react.useCallback)(function () {
    swiper.current && swiper.current.slideToLoop(0, 0);
  }, []);
  var handleSwiperSlideChangeTransitionEnd = (0, _react.useCallback)(function () {
    setSlidesCorrectly(true);
  }, [setSlidesCorrectly]);
  var handleSwiperSlideChangeTransitionStart = (0, _react.useCallback)(function () {
    setSlidesCorrectly(false);
  }, [setSlidesCorrectly]);
  var handleSwiperTouchEnd = (0, _react.useCallback)(function () {
    if (isAutoplayDisableOnInteraction) {
      setAutoplayRunning(false);
    }
  }, [isAutoplayDisableOnInteraction, setAutoplayRunning]);
  var swiperParams = (0, _react.useMemo)(function () {
    var paginationConfig = {
      pagination: {
        bulletActiveClass: 'cds-Slider-PaginationBullet--Active',
        bulletClass: 'cds-Slider-PaginationBullet',
        clickable: true,
        el: '.cds-Slider-Pagination'
      },
      renderPagination: function renderPagination() {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "cds-Slider-Pagination"
        });
      }
    };
    var invisiblePaginationConfig = _objectSpread(_objectSpread({}, paginationConfig), {}, {
      pagination: _objectSpread(_objectSpread({}, paginationConfig.pagination), {}, {
        bulletClass: 'cds-Slider-PaginationBullet--Invisible'
      })
    });
    return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, isPagination ? paginationConfig : invisiblePaginationConfig), isAutoplay && {
      autoplay: {
        delay: autoplayDelay,
        disableOnInteraction: isAutoplayDisableOnInteraction
      }
    }), isLoop && {
      loop: isLoop
    }), spaceBetween && {
      spaceBetween: spaceBetween
    }), slidesPerView && {
      slidesPerView: slidesPerView
    }), slidesPerGroup && {
      slidesPerGroup: slidesPerGroup
    }), breakpoints && {
      breakpoints: breakpoints
    }), {}, {
      centerInsufficientSlides: true,
      containerClass: SLIDER_CONTAINER_CLASS_NAME,
      modules: [_swiper.Autoplay, _swiper.Navigation, _swiper.Pagination],
      navigation: {
        disabledClass: _Arrow.ARROW_DISABLED_CLASS_NAME,
        nextEl: ".".concat(_Arrow.ARROW_TYPE_CLASS_NAME[_Arrow.ARROW_TYPE.next]),
        prevEl: ".".concat(_Arrow.ARROW_TYPE_CLASS_NAME[_Arrow.ARROW_TYPE.prev])
      },
      observer: true,
      on: {
        autoplay: handleSwiperAutoplay,
        observerUpdate: handleSwiperObserverUpdate,
        slideChangeTransitionEnd: handleSwiperSlideChangeTransitionEnd,
        slideChangeTransitionStart: handleSwiperSlideChangeTransitionStart,
        touchEnd: handleSwiperTouchEnd
      },
      renderNextButton: function renderNextButton() {
        return /*#__PURE__*/_react["default"].createElement(_Arrow.Arrow, {
          type: _Arrow.ARROW_TYPE.next
        });
      },
      renderPrevButton: function renderPrevButton() {
        return /*#__PURE__*/_react["default"].createElement(_Arrow.Arrow, {
          type: _Arrow.ARROW_TYPE.prev
        });
      },
      Swiper: _swiper["default"],
      threshold: 10,
      watchOverflow: true
    });
  }, [autoplayDelay, breakpoints, handleSwiperAutoplay, handleSwiperObserverUpdate, handleSwiperSlideChangeTransitionEnd, handleSwiperSlideChangeTransitionStart, handleSwiperTouchEnd, isAutoplay, isAutoplayDisableOnInteraction, isLoop, isPagination, slidesPerGroup, slidesPerView, spaceBetween]);
  (0, _react.useEffect)(function () {
    setTimeout(function () {
      var swiperInstance = swiperElement.current && swiperElement.current.swiper;
      if (!swiper.current) {
        swiper.current = swiperInstance;
      }
    }, 0);
  });
  (0, _react.useEffect)(function () {
    if (swiper.current && isAutoplay) {
      swiper.current.el.addEventListener('mouseenter', setAutoplayStop);
      swiper.current.el.addEventListener('mouseleave', setAutoplayStart);
      return function () {
        swiper.current.el.removeEventListener('mouseenter', setAutoplayStop);
        swiper.current.el.removeEventListener('mouseleave', setAutoplayStart);
      };
    }
  });
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, (0, _getComponentDataAttributes.getComponentDataAttributes)(dataAttributes), {
    className: rootClassName
  }), /*#__PURE__*/_react["default"].createElement(_ReactIdSwiper["default"], (0, _extends2["default"])({}, swiperParams, {
    ref: swiperElement
  }), children));
};
exports.Slider = Slider;